import { useCallback, useState } from 'react'

const MODES = ['list', 'grid']

/**
 * List/grid choice for a collection page, remembered per page in this
 * browser. Storage can be unavailable (private windows, blocked site data),
 * so every access is guarded and the page falls back to `fallback`.
 */
export default function useStoredViewMode(pageKey, fallback = 'list') {
  const storageKey = `xtract.viewMode.${pageKey}`

  const [mode, setMode] = useState(() => {
    try {
      const saved = window.localStorage.getItem(storageKey)
      return MODES.includes(saved) ? saved : fallback
    } catch {
      return fallback
    }
  })

  const update = useCallback((next) => {
    setMode(next)
    try {
      window.localStorage.setItem(storageKey, next)
    } catch {
      // Not persisted; the choice still applies for this visit.
    }
  }, [storageKey])

  return [mode, update]
}
